import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PadContainer } from 'smartsuite-ui/lib/containers/PadContainer';
import { Title } from 'smartsuite-ui/lib/typography/Title';
import { Input } from 'smartsuite-ui/lib/forms/Input';
import BreadCrumb from './BreadCrumb';
import LibraryDashboardsView from './LibraryDashboardsView';
import LibraryWidgetsView from './LibraryWidgetsView';
import SearchResults from './SearchResults';
import { useLabelContext } from '../shared/hooks/labelContext';
import { libraryViews } from '../shared/constants/constants';

export default function WidgetLibrary(props) {
    const { dashboardLabels } = useLabelContext();
    const [searchText, setSearchText] = useState('');
    const [currentView, setCurrentView] = useState(libraryViews.dashboards);
    const [selectedDashboardView, setSelectedDashboardView] = useState({});
    const [showSearch, setShowSearch] = useState(false);

    function goBackToDashboardView() {
        setCurrentView(libraryViews.dashboards);
    }

    function onDashboardSelect(dashboardView) {
        setSelectedDashboardView(dashboardView);
        setCurrentView(libraryViews.widgets);
    }

    function onSearchTextChange(event) {
        setSearchText(event.target.value);
        setShowSearch(!!event.target.value);
    }

    if (!props.isActiveTab) {
        return null;
    }

    return (
        <>
            <PadContainer cssClassModifiers={['pad-medium']}>
                <Title cssClassModifiers={['size-small']}>
                    {dashboardLabels.search}
                </Title>
                <PadContainer cssClassModifiers={['pad-small']} />
                <Input
                    autoFocus={true}
                    isClearable={true}
                    placeholder={dashboardLabels.dashboardOrWidgetTitle}
                    value={searchText}
                    onChange={onSearchTextChange}
                />
            </PadContainer>
            <PadContainer cssClassModifiers={['pad-medium']} />
            <div className="widget-library__content">
                <BreadCrumb
                    currentView={currentView}
                    goBackToDashboardView={goBackToDashboardView}
                    selectedDashboardView={selectedDashboardView}
                />
                <PadContainer cssClassModifiers={['pad-small']} />
                <div className="widget-library__views">
                    <LibraryDashboardsView
                        availableWidgets={props.availableWidgets}
                        isCurrentView={currentView === libraryViews.dashboards}
                        onDashboardSelect={onDashboardSelect}
                    />
                    <LibraryWidgetsView
                        availableWidgets={props.availableWidgets}
                        gridLayout={props.gridLayout}
                        isCurrentView={currentView === libraryViews.widgets}
                        incorrectlyConfiguredDashboards={
                            props.incorrectlyConfiguredDashboards
                        }
                        onAdd={props.onAdd}
                        selectedDashboardView={selectedDashboardView}
                        setDraggingWidget={props.setDraggingWidget}
                    />
                </div>
                <SearchResults
                    availableWidgets={props.availableWidgets}
                    gridLayout={props.gridLayout}
                    showSearch={showSearch}
                    incorrectlyConfiguredDashboards={
                        props.incorrectlyConfiguredDashboards
                    }
                    onAdd={props.onAdd}
                    searchText={searchText}
                    setDraggingWidget={props.setDraggingWidget}
                />
            </div>
        </>
    );
}

WidgetLibrary.propTypes = {
    availableWidgets: PropTypes.instanceOf(Array).isRequired,
    gridLayout: PropTypes.instanceOf(Array).isRequired,
    incorrectlyConfiguredDashboards: PropTypes.instanceOf(Object).isRequired,
    isActiveTab: PropTypes.bool.isRequired,
    onAdd: PropTypes.func.isRequired,
    setDraggingWidget: PropTypes.func.isRequired,
};
